import { TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from '../../../services/api.service';
import { MODAL_CONFIG } from '../../../services/constant';
import { FormBuilder, Validators } from '@angular/forms';
var DepartmentListDetailComponent = (function () {
    function DepartmentListDetailComponent(apiService, formBuilder, modalService, translate) {
        this.apiService = apiService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.translate = translate;
        this.title = '';
        this.createMode = false;
        this.errorMessage = null;
        this.parent = null;
    }
    DepartmentListDetailComponent.prototype.open = function (parent, selectedDepartment) {
        this.parent = parent;
        this.errorMessage = null;
        if (selectedDepartment) {
            this.selectedDepartment = selectedDepartment;
            this.departmentForm.patchValue({
                code: selectedDepartment.code,
                nameEng: selectedDepartment.name_en,
                nameThai: selectedDepartment.name_th,
                abbreviation: selectedDepartment.abbreviation,
                abbCode: selectedDepartment.abb_code,
            });
            this.title = this.translate.instant('DEPARTMENT.LIST.MODAL.TITLE') + ' : ' + selectedDepartment.code;
        }
        else {
            this.title = this.translate.instant('DEPARTMENT.LIST.MODAL.ADD-DEPARTMENT');
        }
        this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
    };
    DepartmentListDetailComponent.prototype.ngOnInit = function () {
        this.departmentForm = this.formBuilder.group({
            code: ['', Validators.required],
            nameEng: ['', Validators.required],
            nameThai: ['', Validators.required],
            abbreviation: ['', Validators.required],
            abbCode: [],
        });
    };
    DepartmentListDetailComponent.prototype.preparedErrorMessage = function () {
        var errorFields = [];
        if (this.translate.currentLang === 'en') {
            if (this.departmentForm.controls.code.errors) {
                errorFields.push('Department ID');
            }
            if (this.departmentForm.controls.nameEng.errors) {
                errorFields.push('Department Name(EN)');
            }
            if (this.departmentForm.controls.nameThai.errors) {
                errorFields.push('Department Name(TH)');
            }
            if (this.departmentForm.controls.abbreviation.errors) {
                errorFields.push('Department Abbreviation');
            }
            this.errorMessage = 'Please fill ' + errorFields.join(', ') + ' correctly';
        }
        else {
            if (this.departmentForm.controls.code.errors) {
                errorFields.push('รหัสแผนก');
            }
            if (this.departmentForm.controls.nameEng.errors) {
                errorFields.push('ชื่อแผนก(ภาษาอังกฤษ)');
            }
            if (this.departmentForm.controls.nameThai.errors) {
                errorFields.push('ชื่อแผนก(ภาษาไทย)');
            }
            if (this.departmentForm.controls.abbreviation.errors) {
                errorFields.push("ตัวอักษรย่อ");
            }
            this.errorMessage = 'โปรดกรอก ' + errorFields.join(', ') + ' ให้ถูกต้อง';
        }
    };
    DepartmentListDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.departmentForm.invalid) {
            this.preparedErrorMessage();
            return;
        }
        var payload = {
            code: this.departmentForm.value.code,
            name_en: this.departmentForm.value.nameEng,
            name_th: this.departmentForm.value.nameThai,
            abbreviation: this.departmentForm.value.abbreviation,
            abb_code: this.departmentForm.value.abbCode,
        };
        var request$ = this.selectedDepartment
            ? this.apiService.updateDepartment(this.selectedDepartment.id, payload)
            : this.apiService.createDepartment(payload);
        request$.subscribe(function () {
            _this.parent.reload();
            _this.modalRef.hide();
            _this.clearData();
        }, function (error) {
            _this.checkErrorMsg(error);
        });
    };
    DepartmentListDetailComponent.prototype.checkErrorMsg = function (error) {
        this.errorMessage = this.apiService.getErrorMessage(error);
    };
    DepartmentListDetailComponent.prototype.clearData = function () {
        this.departmentForm.reset();
        this.selectedDepartment = undefined;
        this.errorMessage = null;
    };
    DepartmentListDetailComponent.prototype.close = function () {
        this.modalRef.hide();
        this.clearData();
    };
    DepartmentListDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_DEPARTMENT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function () { });
    };
    return DepartmentListDetailComponent;
}());
export { DepartmentListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list-detail/department-list-detail.component.ts.pre-build-optimizer.js